import { Link, useNavigate } from 'react-router-dom';
import { useState } from 'react';
import logo from '../assets/logo.png';
import './Home.css';

export default function Home() {
  const navigate = useNavigate();
  const [q, setQ] = useState('');
  function onKey(e) {
    if (e.key === 'Enter') navigate(`/search?q=${encodeURIComponent(q)}`);
  }
  return (
    <div className="home">
      <section className="home-banner">
        <div className="home-hero">
          <img src={logo} alt="Shramajeevi Logo" style={{ width: 160, height: 160, objectFit: 'contain', marginBottom: 16 }} />
          <h1 className="home-title">Discover High‑Quality Images</h1>
          <p className="home-subtitle">Browse categories curated for easy downloads and fast previews.</p>
          <Link to="/downloads" className="home-cta">Browse Images</Link>
          <div className="home-search">
            <div className="search">
              <div className="search-box">
                <input placeholder="Search images..." value={q} onChange={e=>setQ(e.target.value)} onKeyDown={onKey} />
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="home-content info-card">
        <p>
          <br />
          <strong>Shramajeevi Agri Films</strong> is a visual media production house dedicated for agriculture (
          <a target="_blank" rel="noreferrer" href="http://shramajeevi.com/" style={{ color:'blue', textDecoration:'none' }}>www.shramajeevi.com</a>
          ). Basically we produce video documentary films related to farming and other subsidiary activities.
        </p>
        <p>
          All of us come across shortage of natural images of farm activities, crops, varieties, village scenes etc. especially from India. Even if available they are very costly. Print media and also TV channels sometimes, fall short of relevant images for which they cannot go and click instantly. So we decided to share the images that we have and that we can click, with all concerned, through this domain. The images are given as it is. No Photoshop work done.
        </p>
        <p>
          Majority of the images are available for free download. Photos do not carry any watermark or logo except a thin credit line at the lower edge. However we do sell few images for nominal cost for corporate usage on another page of this domain.
        </p>
        <p>
          Our main intention behind this effort is to enrich farm related media service. We hope you will encourage us by using this service.
        </p>
        <p>
          <br />-Team Shramajeevi.<br /><br />
        </p>
      </section>
      <footer className="home-footer">
        <p>
          Shramajeevi Television Private Limited , No. 1108, 1st Floor, 1st Main, 4th Cross, Next to LIC, Kengeri Satellite Town, Bengaluru 560060, Karnataka, India
        </p>
        <p>Mob: +91 9980534320.</p>
        <p>Email: team@shramajeevi.com</p>
      </footer>
    </div>
  );
}

